// extracted by mini-css-extract-plugin
export default {"zoomModal":"o4-z","image":"p4-z","button":"q4-z","isOverlayShown":"r4-z"};